import axios from 'axios';

const LienHolderService = {
  async getLienHolders(id) {
    const response = await axios.get(`/lien_holder`, {
      params: {
        lender_id: id,
      },
    });

    return response.data;
  },

  async getLienHolder(id) {
    const response = await axios.get(`/lien_holder/${id}`);

    return response.data;
  },

  async createLienHolder({ formValues, lenderId }) {
    const response = await axios.post('/lien_holder', {
      ...formValues,
      lender_id: lenderId,
    });

    return response.data;
  },

  async updateLienHolder({ formValues, id, lenderId }) {
    const response = await axios.put(`/lien_holder/${id}`, {
      ...formValues,
      lender_id: lenderId,
    });

    return response.data;
  },

  async getLienHolderWireInstructions(id) {
    const response = await axios.get(`/lien_holder/${id}/wire_instructions`);

    return response.data;
  },
};

export default LienHolderService;
